app.controller("EmployeeStaffController", [
    "$scope", "$uibModal", "SysParam", "StaticData", "ConfirmModal", "$stateParams", "usSpinnerService", "$state", "toastr", "DocumentsService", "OrganizationalUnit",
    function ($scope, $uibModal, SysParam, StaticData, ConfirmModal, $stateParams, usSpinnerService, $state, toastr, DocumentsService, OrganizationalUnit) {

        $scope.staff = [];

        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.positionName = $stateParams.positionName;
        $scope.unit = null;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        if ($stateParams.organizationId) {
            OrganizationalUnit.getById($stateParams.organizationId).then(function (data) {
                $scope.unit = data
            });
        }


        $scope.getUnits = function (query) {
            if (query.length < 2) {
                return [];
            }
            return OrganizationalUnit.findByQuery({ query: query }).then(function (data) {
                return data;
            });
        };

        $scope.goToPage = function (page) {
            $state.go(".", { page: page });

            // loadPage(page);
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                organizationId: $scope.unit ? $scope.unit._id : null,
                positionName: $scope.positionName || null
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            DocumentsService.staffList({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                organizationId: $stateParams.organizationId,
                positionName: $stateParams.positionName
            }).then(function (data) {
                var staff = data.docs;
                usSpinnerService.stop("root");

                staff.forEach(function (employee) {
                    if (!employee.user.photo) {
                        if (employee.user.gender) {
                            if (employee.user.gender === 'male') employee.user.photo = "img/male.jpg";
                            else employee.user.photo = "img/female.jpg";
                        }
                        else {
                            employee.user.photo = "img/no_image.jpg";
                        }
                    }
                });

                $scope.staff = staff;
                $scope.totalItems = data.total;
                cb();
            });
        }

        $scope.add = function () {
            $uibModal.open({
                controller: "EmployeeStaffAddController",
                templateUrl: _pb + 'employee/staff/employee-staff-add.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    toastr.success('', 'თანამშრომელი წარმატებით დაემატა');
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.remove = function (employee) {
            ConfirmModal.show({
                title: "თანამშრომლის წაშლა",
                message: "გსურთ " + employee.user.firstName + " " + employee.user.lastName + " წაშალოთ თანამშრომლების სიიდან?"
            }).result.then(function () {
                usSpinnerService.spin("root");
                DocumentsService.staffRemove(employee).then(function (result) {
                    usSpinnerService.stop("root");
                    toastr.success('', 'თანამშრომელი წარმატებით წაიშალა სიიდან');
                    loadPage($stateParams.page);
                }).catch(function (err) {
                    usSpinnerService.stop("root");
                    if (err.status == 400) {
                        toastr.error('', 'დაფიქსირდა შეცდომა!');
                    }
                });
            });
        };
    }
]);
